import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { colors } from '@startengine/design-system.theme.main';

export const CriteriaBadgeBox = styled(Grid)(({ theme }) => ({
  width: '100%',
  maxWidth: '327px',
  [theme.breakpoints.up('md')]: {
    maxWidth: '370px',
  },
}));

const shouldForwardAppearance = (prop) => prop !== 'appearance';

export const BadgeGrid = styled(Grid, { shouldForwardProp: shouldForwardAppearance })(
  ({ appearance }) => ({
    background: 'linear-gradient(267.36deg, #EFE9E0 14.5%, #F9F5F0 70.58%)',
    borderRadius: '16px',
    padding: '8px 0px',
    width: '100% !important',
    boxShadow:
      '0px 2px 5px 0px #0000000D, 0px 9px 9px 0px #0000000A, 0px 21px 12px 0px #00000005, 0px 37px 15px 0px #00000003, 0px 58px 16px 0px #00000000',
    ...(appearance === 'compactDark' && {
      background: 'rgba(255, 255, 255, 0.08)',
      border: '1px solid rgba(255, 255, 255, 0.18)',
      boxShadow: 'none',
      backdropFilter: 'blur(8px)',
      padding: '4px 8px',
    }),
  }),
);

export const BadgeContainer = styled(Grid, { shouldForwardProp: shouldForwardAppearance })(
  ({ appearance }) => ({
    padding: appearance === 'compactDark' ? '4px' : '6px',
  }),
);

export const BadgeWrapper = styled(Grid, { shouldForwardProp: shouldForwardAppearance })(
  ({ theme, appearance }) => ({
    width: '100%',
    ...(appearance === 'compactDark' && {
      maxWidth: '360px',
      marginLeft: 'auto',
      marginRight: 'auto',
      // The following Builder block intentionally tucks into the hero's
      // bottom padding. Reserve room for the compact badge so that block
      // cannot visually cover it on mobile.
      marginBottom: '48px',
    }),
    [theme.breakpoints.up('sm')]: {
      maxWidth: '327px',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '370px',
    },
  }),
);

export const BadgeTitleTypography = styled(Typography, {
  shouldForwardProp: shouldForwardAppearance,
})(({ theme, appearance }) => ({
  ...theme.typography.h6,
  color: appearance === 'compactDark' ? '#FFFFFF' : colors.SEDark,
}));

export const BadgeSubtitleTypography = styled(Typography, {
  shouldForwardProp: shouldForwardAppearance,
})(({ theme, appearance }) => ({
  ...theme.typography.p2,
  color: appearance === 'compactDark' ? 'rgba(255,255,255,0.72)' : colors.gray1,
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('md')]: {
    ...theme.typography.p3,
  },
}));

export const BadgeDisclaimerTypography = styled(Typography, {
  shouldForwardProp: shouldForwardAppearance,
})(({ theme, appearance }) => ({
  ...theme.typography.p3,
  color: appearance === 'compactDark' ? 'rgba(255,255,255,0.68)' : colors.gray1,
  textAlign: 'center',
}));

export const ActionText = styled('a', { shouldForwardProp: shouldForwardAppearance })(
  ({ theme, appearance }) => ({
    ...theme.typography.p3SemiBold,
    color: appearance === 'compactDark' ? '#F4D247' : theme.palette.common.dark,
    cursor: 'pointer',
    textDecoration: 'none',
  }),
);
